import { useCallback, useEffect, useRef, useState } from 'react';
import clock from '../../../../assets/img/svg/sidebar/clock.svg';
import arrowDown from '../../../../assets/img/svg/sidebar/timezone-arrow-down.svg';
import { useAppSelector } from '../../../../hook/useAppSelector';
import { useAppDispatch } from '../../../../hook/useAppDispatch';
import { fetchTimeZone } from '../../../../store/slice/timezone-slice';
import { useCloseOnScrollAndClickOutside } from '../../../../hook/useCloseOnScrollAndClickOutside';
import Search from '../../Common/Search';
import { t } from 'i18next';
import { updateApplicationConfig } from '../../../../util/update-config';
import { TimeZoneItem } from '../../../../interface/TimeZone';
import { Visibility } from '../../../../enum/Visibility';
import { setSelectedTimeZone } from '../../../../store/slice/config/config';

const TimeZone: React.FC = () => {
  const dispatch = useAppDispatch();
  const selectedTimeZone = useAppSelector((state) => state.configSlice.timeZone);
  const timezoneData = useAppSelector((state) => state.timeZone.timezoneData);
  const [openTimeZoneDropDown, setOpenTimeZoneDropDown] = useState(false);
  const [filteredTimeZones, setFilteredTimeZones] = useState<TimeZoneItem[]>([]);

  const menuRef = useRef<HTMLDivElement>(null);

  const openTimeZone = () => {
    setOpenTimeZoneDropDown((prevState) => !prevState);
  };

  useEffect(() => {
    dispatch(fetchTimeZone());
  }, [dispatch]);

  useCloseOnScrollAndClickOutside(setOpenTimeZoneDropDown, menuRef);

  const handleClick = async (timeZone: string) => {
    dispatch(setSelectedTimeZone(timeZone));
    await updateApplicationConfig({ timeZone }, dispatch);
  };

  const onFilteredData = useCallback((data: any) => {
    setFilteredTimeZones(data);
  }, []);

  return (
    <div className="time_zone_wrapper" ref={menuRef} onClick={openTimeZone}>
      <div className="time_zone">
        <span className="clock">
          <img src={clock} alt="clock"></img>
          <span>{selectedTimeZone}</span>
        </span>
        <img src={arrowDown} alt="arrow_down"></img>
      </div>
      <div
        className={`time_zone_options ${openTimeZoneDropDown ? Visibility.VISIBLE : Visibility.HIDDEN}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="time_zone_options_container">
          <Search
            placeholder={t('general.search')}
            className="time_zone_search"
            data={timezoneData}
            searchKeys={[t('sidebar.timeZone.text')]}
            onFilteredData={onFilteredData}
          />
          <p className="time_zone_title">Time zone</p>
          {filteredTimeZones?.map((timeZone: any, index) => {
            return (
              <div
                className={`time_zone_option ${selectedTimeZone === timeZone.Text ? 'selected_option' : ''}`}
                key={index}
                onClick={() => handleClick(timeZone.Value)}
              >
                {timeZone.Text}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TimeZone;
